<ifc-sign-in [inputData]="data">
  <ng-container *ngIf="displayBanner">
    <ng-template #banner>
      <ifc-mobile-app-banner></ifc-mobile-app-banner>
    </ng-template>
  </ng-container>
</ifc-sign-in>
